'use client';

import { useSidebar } from '@/app/context/SidebarContext';

export default function MobileMenuButton() {
  const { toggleMobile } = useSidebar();

  return (
    <button
      onClick={toggleMobile}
      style={{
        top: 'calc(0.75rem + env(safe-area-inset-top) + var(--ad-anchor-top, 0px))',
        left: 'calc(0.75rem + env(safe-area-inset-left))',
      }}
      className="lg:hidden fixed z-30 p-3 bg-zinc-800 border border-zinc-700 rounded-lg text-zinc-300 hover:text-white hover:bg-zinc-700 transition-colors"
      aria-label="Toggle menu"
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  );
}
